export class Nav {
    init() {
        var self = this;
        $(document).ready(function() {
            $('nav.navbar .navbar-toggler').click(function () {
                let _this = this,
                    icon = $('nav.navbar .navbar-toggler .navbar-toggler-icon');
                _this.classList.add('locked');

                if (icon.hasClass('opened')) {
                    _this.classList.remove('opened');
                    icon.removeClass('opened');
                    $('body').removeClass('blocked');
                }else{
                    $('body').addClass('blocked');
                    _this.classList.add('opened');
                    icon.addClass('opened').addClass('closed');
                }
                setTimeout(function(){
                    _this.classList.remove('locked');
                },750);
            });
        })

    }
    delay(elem,direction, unlock = false){
        elem.each(function(index) {
            if(direction){
                if(window.innerWidth > 1200){
                    $(this).css('transition-delay', (100+(50*index) + 'ms'));
                }
                $(elem).removeClass('visible')
            }else{
                $(elem).addClass('visible')
                if(window.innerWidth > 1200){
                    $(this).css('transition-delay', (500+(50*(elem.length - index)) + 'ms'));
                }
            }
            if(unlock){
                setTimeout(function() {
                    $('nav.navbar .navbar-toggler').removeClass('locked');
                }, (500+(50*(elem.length - index))))
            }
        });
    }
}